import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const CheckoutSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countdown, setCountdown] = useState(5);

  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get('session_id');

  useEffect(() => {
    // Countdown to redirect
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          navigate('/dashboard');
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-xl p-8 text-center">
          {/* Success Icon */}
          <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-green-100 mb-6">
            <svg className="h-12 w-12 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>

          {/* Success Message */}
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            🎉 Welcome to CyberGuard!
          </h1>
          
          <p className="text-lg text-gray-700 mb-6">
            Your 14-day free trial has started successfully!
          </p>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <p className="text-sm text-blue-900 mb-2">
              <strong>What happens next?</strong>
            </p>
            <ul className="text-sm text-blue-800 text-left space-y-2">
              <li>✓ Check your email for confirmation</li>
              <li>✓ Set up your security dashboard</li>
              <li>✓ Start protecting your devices</li>
              <li>✓ You won't be charged for 14 days</li>
            </ul>
          </div>

          {/* Session ID (for debugging) */}
          {sessionId && (
            <p className="text-xs text-gray-500 mb-6">
              Session ID: {sessionId.substring(0, 20)}...
            </p>
          )}

          {/* Redirect Info */}
          <p className="text-gray-600 mb-6">
            Redirecting to your dashboard in <span className="font-bold text-blue-600">{countdown}</span> seconds...
          </p>

          {/* Manual Redirect Button */}
          <button
            onClick={() => navigate('/dashboard')}
            className="w-full bg-blue-600 text-white py-3 rounded-lg font-semibold hover:bg-blue-700 transition"
          >
            Go to Dashboard Now
          </button>

          {/* Support Link */}
          <p className="mt-6 text-sm text-gray-600">
            Need help? <a href="mailto:support@aslandefense.com" className="text-blue-600 hover:text-blue-700">Contact Support</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccess;